import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

import { getThumbnailUrl } from "Data/media/MediaSelectors";

import Modal from "UI/Modal";
import Button from "UI/Button";
import Toggle from "UI/Toggle/Toggle";
import UploadDropzone from "Components/UploadDropzone";
import UploadList from "Components/UploadList";

import { PhotographIcon } from "@heroicons/react/outline";

export default function MediaSelectModal({open, onClose, media, value, onChange}) {
    const selectButtonRef = useRef();
    const [selectedId, setSelectedId] = useState(null);
    const [uploading, setUploading] = useState(false);

    const classes = {
        modal: classNames(
            'w-full h-full md:max-h-xl md:w-3/4'
        ),
        grid: classNames(
            'grid grid-cols-2 gap-x-4 gap-y-8',
            'sm:grid-cols-3 sm:gap-x-6',
            'lg:grid-cols-4',
            'xl:grid-cols-5',
            '2xl:grid-cols-6'
        )
    };

    return <Modal
        open={open}
        onClose={onClose}
        initialFocus={selectButtonRef}
        className={classes.modal}
    >
        <Modal.Header className="inline-flex items-center bg-indigo-500 text-white">
            <PhotographIcon className='w-5 inline-block mr-2' /> Change Media

            {
                /*
                <div className='flex-grow' />
                <UploadButton onClick={() => setUploading(true)} />
                <UploadDialog open={uploading} multiple onClose={() => setUploading(false)} />
                */
            }

        </Modal.Header>
        <div className='p-4 py-2 bg-gray-50 flex flex-row-reverse'>
            <Toggle label='Upload' enabled={uploading} onChange={setUploading} />
        </div>

        {
            uploading && <UploadDropzone className='p-4' multiple />
        }

        <Modal.Content>
            {
                !uploading &&
                <div onDragOver={() => setUploading(true)}>
                    <ul role="list" className={classNames('mt-4', classes.grid)}>
                        {
                            media.map((file) => (
                                <Item
                                    key={file.id}
                                    file={file}
                                    onSelect={setSelectedId}
                                    selected={file.id === selectedId}
                                    current={file.id === value}
                                />
                            ))
                        }
                    </ul>
                </div>
            }

            {
                uploading && <UploadList />
            }
        </Modal.Content>
        <Modal.Footer>
            {
                selectedId && value !== selectedId && <Button type='primary' ref={selectButtonRef} onClick={() => { onChange(selectedId); onClose()} }>
                    Update
                </Button>
            }
            <Button type='plain' onClick={onClose}>Cancel</Button>
        </Modal.Footer>
    </Modal>;
}

MediaSelectModal.propTypes = {
    open: PropTypes.bool.isRequired
};

MediaSelectModal.defaultProps = {

};

const Item = ({file, onSelect, selected, current}) => {

    const classes = classNames(
        'focus:outline-none group block w-full aspect-w-10 aspect-h-7 rounded-lg overflow-hidden',
        {
            'ring-2 ring-offset-2': selected || current,
            'ring-indigo-500': selected,
            'ring-gray-300': current,
        }
    );

    const url = getThumbnailUrl(file, 200, 200);

    return <li key={file.id} className="relative">
        <button
            onClick={() => onSelect(file.id)}
            className={classes}
        >
            <img src={url} alt="" className="group-hover:opacity-75 object-cover pointer-events-none" />
        </button>
        <p className="mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none">{file.label}</p>
        <p className="block text-sm font-medium text-gray-500 pointer-events-none">{file.size}</p>
    </li>
};
